<script>
import {ref} from "vue";
import {useRoute} from "vue-router";
import FreeWorld from "@/assets/js/FreeWorld";
import Swals from "@/assets/js/Swals";

export default {
  name: "PrivacyPage",
  setup(){

    let loading = ref(false)
    let action_page = ref(useRoute().params.action)
    let details = ref()

    function get_privacy() {
      loading.value = true
      FreeWorld.Heisenberg({action:action_page.value} , 'public_info').then((res)=>{
        loading.value = false
        details.value = res.data
      }).catch((res)=>{
        loading.value = false
        Swals.Catch(res , get_privacy)
      })
    }
    get_privacy()

    return{
      loading,
      action_page,
      details,
    }
  }
}
</script>

<template>
  
  <div id="main" :class="loading ? 'activeClass':''" class="bg-color-liner">
    <div style="height: 5rem" class="d-flex align-items-center p-4">
      <img onclick="window.history.back()" class="icon-size-1 rounded-pill ms-3" src="../assets/img/icon-back.svg" alt="">
      <p v-if="action_page === 'apprules'" class="text-white font-bold font-4">شرایط و قوانین</p>
      <p v-if="action_page === 'about_us'" class="text-white font-bold font-4">درباره ما</p>
      <p v-if="action_page === 'privacy'" class="text-white font-bold font-4">حریم خصوصی</p>
    </div>

    <div id="chile-main" class="bg-main rounded-top-5 p-3 pt-4">
      <div v-html="details" class=""></div>
    </div>
  </div>

</template>

<style scoped>

</style>